import { render, staticRenderFns } from "./ks.vue?vue&type=template&id=1c2e9980&scoped=true"
import script from "./ks.vue?vue&type=script&lang=js"
export * from "./ks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e9980",
  null
  
)

export default component.exports